const metaModelName = `meta.primaryNationalIdentification`;

export const primaryNationalIdentificationMetaName = {
  valueRequired: `${metaModelName}.required.value`,
  validUntilRequired: `${metaModelName}.required.validUntil`,
  confirmEmptyValue: `${metaModelName}.confirmEmptyValue`,
  confirmSsn: `${metaModelName}.confirmSsn`
};
